export default __webpack_public_path__ + "static/media/Pie-Chart-Style_1.4221881a.png";